import Hero from "../sections/Hero";
import House from "../sections/House";
import LatestEdit from "../sections/LatestEdit";
import Collections from "../sections/Collections";
import Bespoke from "../sections/Bespoke";
import TheEdit from "../sections/TheEdit";
import Stories from "../sections/Stories";
import Designer from "../sections/Designer";
import Global from "../sections/Global";
import Categories from "../sections/Categories";
import Social from "../sections/Social";
import FinalCTA from "../sections/FinalCTA";

export default function HomePage() {
  return (
    <div data-testid="home-page">
      <Hero />
      <House />
      <LatestEdit />
      <Collections />
      <Bespoke />
      <TheEdit />
      <Stories />
      <Designer />
      <Global />
      <Categories />
      <Social />
      <FinalCTA />
    </div>
  );
}
